import { render, staticRenderFns } from "./cadastroPf.vue?vue&type=template&id=12efe86a&scoped=true&"
import script from "./cadastroPf.vue?vue&type=script&lang=js&"
export * from "./cadastroPf.vue?vue&type=script&lang=js&"
import style0 from "./cadastroPf.vue?vue&type=style&index=0&id=12efe86a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12efe86a",
  null
  
)

export default component.exports